export const blogCategories = [
  { id: 'all', label: '全部' },
  { id: 'trends', label: '行业趋势' },
  { id: 'tech', label: '技术洞察' },
  { id: 'carbon', label: '碳中和' },
  { id: 'policy', label: '政策法规' },
  { id: 'cases', label: '案例实践' },
];

export const blogPosts = [
  {
    id: 'cbam-deep-dive',
    slug: 'cbam-explained-mechanism-and-impact',
    category: 'policy',
    categoryLabel: '政策法规',
    date: '2025.05.06',
    readTime: '11 分钟',
    title: '深度解读 CBAM：欧盟碳边境调节机制的运作原理、计算方法与全球影响',
    excerpt: 'CBAM 究竟如何计算、为何而设、将如何演变？本文从机制设计的第一性原理出发，系统拆解 CBAM 的立法背景、隐含排放核算规则、证书清算逻辑，以及对全球贸易格局的深远影响。',
    image: 'https://readdy.ai/api/search-image?query=european%20union%20flag%20carbon%20emission%20factory%20chimneys%20trade%20cargo%20ships%20digital%20data%20overlay%20policy%20regulation%20concept%20dark%20background%20professional%20tech%20illustration&width=600&height=340&seq=blog7&orientation=landscape',
    author: {
      name: '张小奎',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20tech%20CEO%20portrait%20headshot%20wearing%20dark%20suit%20confident%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=60&height=60&seq=bauth1&orientation=squarish',
      title: 'Firmai 创始人 & CEO',
    },
    tags: ['CBAM', '碳边境税', '欧盟碳市场', 'EU ETS', '出口合规'],
    content: `
## 一、CBAM 为何而生：碳泄漏问题的根源

欧盟自 2005 年起运行碳排放交易体系（EU ETS），域内高耗能企业为每吨碳排放付费。但这带来一个结构性漏洞：当欧盟企业的碳成本持续上升，而进口产品的原产国没有同等碳定价时，生产环节会倾向于转移到监管更宽松的地区，产品再进口回欧盟——总排放量并未下降，只是转移了地理位置。这一现象被称为"碳泄漏"（Carbon Leakage）。

CBAM（Carbon Border Adjustment Mechanism，碳边境调节机制）正是为堵住这个漏洞而设计：对进口到欧盟的高碳产品，按其隐含碳排放量征收相当于欧盟碳价的费用，使境外生产商与境内生产商站在同一条碳成本起跑线上。

## 二、立法时间线与实施阶段

- **2021 年 7 月**：欧盟委员会发布 CBAM 立法提案，作为"Fit for 55"一揽子气候法案的一部分。
- **2023 年 5 月**：CBAM 法规正式生效。
- **2023 年 10 月 – 2025 年 12 月**：过渡期。进口商只需按季度申报产品隐含碳排放数据，无需实际付费购买证书。
- **2026 年 1 月起**：正式实施阶段开始，进口商须购买并清缴 CBAM 证书，与免费配额同步退坡机制挂钩。

## 三、覆盖范围：从六大行业到潜在扩容

现行 CBAM 覆盖水泥、钢铁、铝、化肥、电力、氢气六大类产品，这些行业具备两个共同特征：高碳排放强度、国际贸易中容易被碳泄漏影响。欧盟已明确表示，2026 年后将评估把有机化学品、塑料等下游加工品纳入覆盖范围，出口企业应提前关注供应链上下游产品是否可能被纳入。

## 四、核心计算逻辑：隐含碳排放如何折算成费用

CBAM 的计算并不复杂，但环节较多，理解每一步的逻辑才能准确测算成本敞口。

### 1. 隐含排放（Embedded Emissions）

每单位产品的隐含排放 = 直接排放（生产过程燃烧、工艺排放）+ 间接排放（外购电力对应的碳排放）。计算需依据欧盟规定的方法学，优先使用企业实测数据，缺失时可使用欧盟公布的默认值，但默认值通常显著高于实际值，企业有强烈动机自证真实排放数据。

### 2. 免费配额抵扣

参考欧盟本地同类生产商在 EU ETS 下获得的免费配额比例，进口产品的隐含排放中对应比例部分可被抵扣，无需支付。这一免费配额比例会逐年下降（与欧盟本地企业的免费配额退坡节奏同步），意味着抵扣空间逐年收窄，实际征收比例逐年上升。

### 3. 已缴碳价扣除

若产品在原产国已经缴纳了碳税或参与了碳市场（如中国全国碳市场），已支付的碳成本可从 CBAM 应缴费用中扣除，避免双重征税。这要求企业保留完整的碳价支付凭证。

### 4. CBAM 证书价格

证书价格与 EU ETS 每周拍卖均价挂钩，随欧盟碳市场价格波动。进口商需按季度核算应缴证书数量并完成清缴。

**简化公式**：
应缴 CBAM 费用 = (隐含排放量 − 已抵扣免费配额对应排放 − 原产国已缴碳价折算排放) × EU ETS 周均碳价

## 五、对不同主体的影响差异

### 出口企业
直接面临新增合规成本和申报负担，尤其是钢铁、铝、化肥等高碳强度行业的出口商，利润率可能被压缩数个百分点。

### 欧盟进口商
CBAM 的申报和缴费义务法律上落在进口商身上，这意味着欧盟买家会将碳排放数据要求向上游供应商传导，倒逼出口企业提升碳数据透明度，否则可能被从供应链中替换。

### 全球贸易格局
CBAM 实质上是把欧盟碳定价"出口"到了全球贸易伙伴。其他经济体（如英国、美国部分提案）已在研究类似机制，未来出口企业可能面临多个碳边境税体系的叠加合规要求。

## 六、企业应如何构建 CBAM 数据能力

CBAM 合规的核心瓶颈往往不是策略，而是数据：能否按产品、按批次、按生产环节拆解出准确的直接和间接碳排放数据。这要求企业具备：

1. **产线级能耗与工艺数据采集**：区分不同产品线、不同生产批次的能源消耗和工艺排放。
2. **电力排放因子对接**：准确获取外购电力的排放因子，并留存采购凭证。
3. **碳价缴纳记录归档**：完整保存原产国碳税或碳市场的缴费凭证，用于抵扣申报。
4. **自动化申报报表生成**：将底层数据自动转化为符合欧盟 CBAM 申报模板要求的格式，减少人工整理误差。

Firmai 平台的碳排放追踪模块支持产线级数据颗粒度采集，并可直接生成符合 CBAM 申报要求的隐含排放报告，帮助企业在过渡期就建立起经得起核查的数据基础。

## 结语

CBAM 不是一次性的合规事件，而是欧盟碳定价体系向全球贸易延伸的长期制度安排。免费配额的持续退坡意味着实际征收成本会逐年走高，越早建立起精细化、可追溯的碳排放数据能力，企业在成本测算和供应链谈判中就越主动。
    `,
  },
  {
    id: 'energy-trends-2025',
    slug: '2025-energy-management-trends',
    category: 'trends',
    categoryLabel: '行业趋势',
    date: '2025.04.15',
    readTime: '8 分钟',
    title: '2025年企业能源管理十大趋势：AI驱动下的智能化转型',
    excerpt: '随着碳中和目标的推进，企业能源管理正经历前所未有的变革。本文深入分析AI、物联网和大数据如何重塑能源管理格局，以及企业应如何把握机遇。',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20smart%20city%20with%20green%20energy%20infrastructure%20wind%20turbines%20solar%20panels%20digital%20overlay%20holographic%20data%20visualization%20dark%20background%20professional%20tech%20illustration&width=600&height=340&seq=blog1&orientation=landscape',
    author: {
      name: '张小奎',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20tech%20CEO%20portrait%20headshot%20wearing%20dark%20suit%20confident%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=60&height=60&seq=bauth1&orientation=squarish',
      title: 'Firmai 创始人 & CEO',
    },
    tags: ['AI', '能源管理', '数字化转型', '碳中和'],
    content: `
## 引言

2025年，企业能源管理领域正在经历一场由人工智能驱动的深刻变革。随着全球碳中和目标的推进和能源成本的持续攀升，企业对于精细化、智能化能源管理的需求达到了前所未有的高度。

## 趋势一：AI 预测性维护成为标配

传统的设备维护模式正在被 AI 驱动的预测性维护所取代。通过分析设备运行数据，AI 系统可以提前 7-30 天预测设备故障，准确率达到 95% 以上。这不仅大幅降低了非计划停机时间，还延长了设备使用寿命。

## 趋势二：数字孪生技术广泛应用

数字孪生技术让企业可以在虚拟环境中模拟和优化能源系统。通过创建物理设备的数字副本，企业可以在不影响实际生产的情况下测试不同的能源策略，找到最优方案。

## 趋势三：碳排放实时追踪成为合规刚需

随着欧盟 CBAM 和中国碳市场的推进，企业需要实时、精确地追踪碳排放数据。这不再是可选项，而是合规的硬性要求。

## 趋势四：边缘计算降低数据处理延迟

在能源管理场景中，毫秒级的响应时间至关重要。边缘计算将数据处理能力下沉到设备端，将延迟从秒级降低到毫秒级。

## 趋势五：能源即服务（EaaS）模式兴起

越来越多的企业选择将能源管理外包给专业服务商，采用订阅制模式获取能源管理服务，降低初期投入成本。

## 趋势六：多能源协同优化

企业不再只关注电力，而是将电、水、气、热等多种能源纳入统一管理平台，实现跨能源类型的协同优化。

## 趋势七：员工行为能耗分析

通过分析员工的行为模式，企业可以发现隐藏的能耗浪费点。例如，下班后未关闭的设备、空调温度设置不合理等。

## 趋势八：区块链赋能碳交易

区块链技术为碳排放数据提供了不可篡改的记录，增强了碳交易的可信度和透明度。

## 趋势九：绿色金融与能源管理融合

银行和投资机构越来越关注企业的能源管理水平和碳排放表现，这直接影响融资成本和估值。

## 趋势十：大模型赋能自然语言交互

基于大语言模型的能源顾问可以回答复杂的能源管理问题，生成专业的分析报告，大幅降低使用门槛。

## 结语

2025年是企业能源管理智能化的关键之年。那些率先拥抱 AI 和数字化转型的企业，将在成本控制、合规管理和品牌声誉方面获得显著优势。Firmai 平台正是基于这些趋势而设计，帮助企业把握能源管理的未来。
    `,
  },
  {
    id: 'predictive-maintenance',
    slug: 'predictive-maintenance-revolution',
    category: 'tech',
    categoryLabel: '技术洞察',
    date: '2025.04.08',
    readTime: '6 分钟',
    title: '预测性维护：从被动维修到主动预防的能源设备管理革命',
    excerpt: '传统设备维护模式已无法满足现代工业需求。基于机器学习的预测性维护技术正在改变这一现状，帮助企业将设备故障率降低 60% 以上。',
    image: 'https://readdy.ai/api/search-image?query=industrial%20IoT%20sensors%20and%20smart%20meters%20connected%20in%20network%20digital%20data%20flow%20green%20glowing%20lines%20dark%20background%20professional%20tech%20illustration&width=600&height=340&seq=blog2&orientation=landscape',
    author: {
      name: '刘浩然',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20data%20scientist%20portrait%20headshot%20wearing%20turtleneck%20intellectual%20look%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=60&height=60&seq=bauth2&orientation=squarish',
      title: 'Firmai 首席科学家',
    },
    tags: ['预测性维护', '机器学习', 'IoT', '设备管理'],
    content: `
## 传统维护模式的困境

在传统的工业设备维护中，企业通常采用两种策略：被动维修和定期保养。被动维修意味着等到设备坏了再修，这会导致生产中断和高昂的紧急维修成本。定期保养虽然能预防一些故障，但往往是"一刀切"的，既浪费资源又无法精准预防。

## 什么是预测性维护？

预测性维护（Predictive Maintenance, PdM）是一种基于数据驱动的维护策略。它通过持续监测设备的运行状态，利用机器学习算法分析数据模式，在故障发生前预测设备的健康状况，从而在最合适的时间进行维护。

## 核心技术原理

### 1. 多维度数据采集

预测性维护系统需要采集多种类型的数据：
- **振动数据**：通过加速度传感器监测设备振动频谱
- **温度数据**：红外热成像和温度传感器
- **电流数据**：电机电流特征分析
- **声音数据**：声学传感器捕捉异常噪音
- **油液数据**：润滑油品质分析

### 2. 特征工程与模式识别

原始数据需要经过特征提取，转化为机器学习模型可以理解的特征向量。常用的特征包括：
- 时域特征：均值、方差、峰值、峭度
- 频域特征：FFT 频谱、功率谱密度
- 时频特征：小波变换系数

### 3. 机器学习模型

Firmai 平台采用集成学习策略，结合多种算法：
- **随机森林**：处理高维特征，提供特征重要性排序
- **LSTM 网络**：捕捉时间序列中的长期依赖关系
- **孤立森林**：检测异常数据点
- **生存分析**：预测设备剩余使用寿命（RUL）

## 实际应用效果

根据 Firmai 服务客户的实际数据：
- 设备故障率降低 60%
- 非计划停机时间减少 75%
- 维护成本降低 35%
- 设备使用寿命延长 20%

## 实施建议

对于希望引入预测性维护的企业，建议分三步走：
1. **试点阶段**：选择 3-5 台关键设备进行试点
2. **扩展阶段**：将成功经验推广到同类设备
3. **全面阶段**：建立企业级预测性维护平台

## 结语

预测性维护不是未来科技，而是现在就可以落地的实用技术。它代表了设备管理从"经验驱动"到"数据驱动"的根本转变。
    `,
  },
  {
    id: 'carbon-footprint-guide',
    slug: 'carbon-footprint-accounting-guide',
    category: 'carbon',
    categoryLabel: '碳中和',
    date: '2025.03.28',
    readTime: '10 分钟',
    title: '企业碳足迹核算实战指南：从数据采集到报告生成',
    excerpt: '碳足迹核算是企业实现碳中和的第一步。本文提供一套完整的实操方法论，帮助企业建立科学的碳管理体系。',
    image: 'https://readdy.ai/api/search-image?query=carbon%20footprint%20tracking%20dashboard%20with%20green%20leaf%20icons%20data%20charts%20environmental%20metrics%20dark%20background%20professional%20tech%20illustration&width=600&height=340&seq=blog3&orientation=landscape',
    author: {
      name: '李雪婷',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20business%20executive%20portrait%20headshot%20wearing%20blazer%20confident%20smile%20clean%20background%20corporate%20photography&width=60&height=60&seq=bauth3&orientation=squarish',
      title: '碳管理专家',
    },
    tags: ['碳足迹', '碳核算', 'ISO 14064', '碳中和'],
    content: `
## 为什么碳足迹核算如此重要？

在全球碳中和的大背景下，企业碳足迹核算已经从"可选项"变成了"必选项"。无论是应对欧盟 CBAM、满足供应链碳披露要求，还是参与中国碳市场交易，精确的碳足迹数据都是基础。

## 碳足迹核算的三个范围

根据温室气体核算体系（GHG Protocol），企业碳排放分为三个范围：

### 范围一：直接排放
企业拥有或控制的排放源产生的排放，包括：
- 固定燃烧（锅炉、发电机组）
- 移动燃烧（公司车辆）
- 工艺排放（化工生产）
- 无组织排放（制冷剂泄漏）

### 范围二：间接排放（电力）
企业购买电力、热力产生的间接排放。这是大多数企业碳排放的主要来源。

### 范围三：价值链排放
企业价值链上下游产生的排放，包括：
- 采购商品和服务
- 运输和配送
- 员工通勤
- 产品使用和处理

## 数据采集方法

### 1. 活动数据收集

建立标准化的数据采集模板，包括：
- 能源账单（电、气、油）
- 生产记录（产量、原料消耗）
- 运输记录（里程、载重）
- 差旅记录（航班、酒店）

### 2. 排放因子选择

使用权威的排放因子数据库：
- 中国：国家温室气体排放因子库
- 国际：IPCC、DEFRA、EPA
- 行业：行业协会发布的特定因子

### 3. 数据质量控制

建立数据质量评级体系：
- A级：实测数据（如连续排放监测系统）
- B级：基于活动数据和排放因子的计算
- C级：基于估算和默认值

## 核算工具与平台

Firmai 碳排放管理平台提供：
- 自动数据采集（对接电表、气表、ERP 系统）
- 内置排放因子库（覆盖 50+ 行业）
- 实时碳排放计算与可视化
- 自动生成符合 ISO 14064 标准的报告

## 报告生成与披露

### 报告内容框架
1. 组织边界与报告边界
2. 核算方法与排放因子
3. 范围一、二、三排放数据
4. 减排目标与进展
5. 第三方核证声明

### 披露渠道
- 企业可持续发展报告（ESG 报告）
- CDP（碳披露项目）问卷
- 交易所强制披露（如适用）

## 常见误区与建议

### 误区一：只算范围一和二
范围三排放往往占企业总排放的 70% 以上，忽略范围三会严重低估碳足迹。

### 误区二：使用过时排放因子
排放因子应每年更新，使用 5 年前的因子可能导致 20% 以上的误差。

### 误区三：缺乏数据追溯性
所有数据都应有来源记录，便于审计和核证。

## 结语

碳足迹核算是一项系统工程，需要技术、管理和文化的协同。Firmai 平台帮助企业将复杂的碳核算流程自动化、标准化，让碳管理变得简单高效。
    `,
  },
  {
    id: 'cbam-compliance',
    slug: 'cbam-compliance-strategy',
    category: 'policy',
    categoryLabel: '政策法规',
    date: '2025.03.20',
    readTime: '7 分钟',
    title: 'CBAM 碳边境调节机制：出口企业合规策略全解析',
    excerpt: '欧盟 CBAM 法规已正式实施，对中国出口企业影响深远。本文详解 CBAM 申报流程、成本测算和应对策略。',
    image: 'https://readdy.ai/api/search-image?query=global%20carbon%20border%20regulation%20concept%20world%20map%20with%20trade%20routes%20carbon%20footprint%20tracking%20digital%20interface%20dark%20background%20professional%20tech%20illustration&width=600&height=340&seq=blog4&orientation=landscape',
    author: {
      name: '张雪晴',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20marketing%20VP%20portrait%20headshot%20wearing%20elegant%20blouse%20warm%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=60&height=60&seq=bauth4&orientation=squarish',
      title: 'Firmai VP 市场',
    },
    tags: ['CBAM', '欧盟法规', '出口合规', '碳关税'],
    content: `
## CBAM 是什么？

碳边境调节机制（Carbon Border Adjustment Mechanism，CBAM）是欧盟推出的贸易政策工具，旨在防止"碳泄漏"——即高碳排放产业从碳定价严格的欧盟转移到碳定价宽松的国家。

## CBAM 覆盖的产品范围

目前 CBAM 覆盖六大类产品：
1. 水泥
2. 钢铁
3. 铝
4. 化肥
5. 电力
6. 氢气

未来可能扩展到更多行业。

## 申报流程详解

### 第一步：确定产品隐含碳排放

计算每吨产品的直接和间接碳排放：
- 直接排放：生产过程中的燃料燃烧和工艺排放
- 间接排放：外购电力的碳排放

### 第二步：扣除欧盟免费配额

如果产品在欧盟生产，可以获得一定比例的免费碳配额。进口产品需要扣除相应的免费配额后，才需要购买 CBAM 证书。

### 第三步：购买 CBAM 证书

CBAM 证书的价格与欧盟碳市场（EU ETS）的碳价挂钩。企业需要按季度购买并上缴 CBAM 证书。

## 成本测算示例

以钢铁出口为例：
- 假设：出口 10,000 吨钢材到欧盟
- 隐含碳排放：1.8 吨 CO2/吨钢
- 欧盟碳价：80 欧元/吨 CO2
- CBAM 成本 = 10,000 × 1.8 × 80 = 144 万欧元

这相当于每吨钢材增加 144 欧元的成本，对利润率的影响不可忽视。

## 企业应对策略

### 短期策略（1-2 年）
1. 建立 CBAM 数据收集体系
2. 培训相关人员掌握申报流程
3. 与欧盟进口商沟通数据需求

### 中期策略（2-5 年）
1. 优化生产工艺降低碳排放强度
2. 使用绿电替代化石能源电力
3. 考虑在欧盟本地设厂规避 CBAM

### 长期策略（5 年以上）
1. 全面转型低碳生产
2. 参与中国碳市场获取碳资产
3. 开发 CCER 项目抵消碳排放

## Firmai CBAM 解决方案

Firmai 平台提供一站式 CBAM 合规服务：
- 产品碳足迹自动核算
- CBAM 季度报告自动生成
- 隐含碳排放强度计算与对标
- 欧盟 MRV 体系对接支持
- 碳关税成本预测与优化策略

## 结语

CBAM 不是短期的贸易壁垒，而是全球碳定价趋势的一部分。企业应将 CBAM 合规视为推动自身低碳转型的契机，而非单纯的成本负担。
    `,
  },
  {
    id: 'green-factory-certification',
    slug: 'green-factory-certification-guide',
    category: 'cases',
    categoryLabel: '案例实践',
    date: '2025.03.10',
    readTime: '9 分钟',
    title: '绿色工厂认证全流程解析：从申报到拿证的实战经验',
    excerpt: '工信部绿色工厂认证是企业绿色转型的重要里程碑。本文分享 Firmai 服务 200+ 企业成功认证的实战经验。',
    image: 'https://readdy.ai/api/search-image?query=modern%20sustainable%20green%20factory%20building%20with%20solar%20panels%20wind%20turbines%20clean%20energy%20infrastructure%20lush%20greenery%20surrounding%20professional%20corporate%20photography%20bright%20daylight&width=600&height=340&seq=blog5&orientation=landscape',
    author: {
      name: '王志强',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20product%20VP%20portrait%20headshot%20wearing%20glasses%20blazer%20friendly%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=60&height=60&seq=bauth5&orientation=squarish',
      title: 'Firmai VP 产品',
    },
    tags: ['绿色工厂', '工信部认证', 'ISO 50001', '绿色制造'],
    content: `
## 什么是绿色工厂？

绿色工厂是工信部绿色制造体系的重要组成部分，指实现了用地集约化、原料无害化、生产洁净化、废物资源化、能源低碳化的工厂。

## 绿色工厂评价体系

评价指标分为基础设施、管理体系、能源资源投入、产品、环境排放、绩效六大类，满分 100 分。

### 关键指标权重
- 能源低碳化（25%）
- 环境排放（20%）
- 绩效（20%）
- 管理体系（15%）
- 产品（10%）
- 基础设施（10%）

## 申报流程

### 第一阶段：自评价（2-3 个月）
1. 组建绿色工厂申报团队
2. 对照评价标准进行差距分析
3. 制定改进计划并实施
4. 编制自评价报告

### 第二阶段：第三方评价（1 个月）
1. 选择有资质的第三方评价机构
2. 提交自评价报告和相关证明材料
3. 接受现场核查
4. 获取第三方评价报告

### 第三阶段：省级推荐（1 个月）
1. 向当地工信部门提交申报材料
2. 通过省级初审
3. 获得省级推荐函

### 第四阶段：国家级评审（2-3 个月）
1. 工信部组织专家评审
2. 可能需要补充材料或答辩
3. 公示拟入选名单
4. 正式发布绿色工厂名单

## 常见难点与解决方案

### 难点一：能源数据不完整
**解决方案**：部署 Firmai 实时监测平台，自动采集全厂能源数据，生成符合申报要求的能耗报表。

### 难点二：碳排放核算不准确
**解决方案**：使用 Firmai 碳排放追踪模块，自动计算范围一、二、三排放，确保数据准确可追溯。

### 难点三：管理体系文件缺失
**解决方案**：Firmai 提供 ISO 50001 能源管理体系认证辅导，帮助企业建立完整的管理文件体系。

## 认证后的价值

获得绿色工厂认证后，企业可以享受：
- 政府补贴和奖励（各地政策不同，通常 50-200 万元）
- 绿色金融优惠（绿色信贷利率下浮 10-30%）
- 招投标加分（部分政府采购项目要求绿色工厂）
- 品牌增值（提升 ESG 评级和客户信任度）

## Firmai 绿色工厂服务

Firmai 提供从申报准备到拿证的全流程服务：
- 绿色工厂自评价报告自动生成
- 能源管理体系 ISO 50001 认证辅导
- 能耗限额对标分析与优化建议
- 第三方审核全流程陪同服务
- 绿色供应链协同管理平台

## 结语

绿色工厂认证不是终点，而是企业绿色转型的起点。通过认证过程中的系统梳理和改进，企业可以建立可持续的能源管理和碳排放控制体系。
    `,
  },
  {
    id: 'ccer-project-development',
    slug: 'ccer-carbon-credit-development',
    category: 'carbon',
    categoryLabel: '碳中和',
    date: '2025.02.28',
    readTime: '8 分钟',
    title: 'CCER 项目开发实战：将减排成果转化为碳资产',
    excerpt: '国家核证自愿减排量（CCER）重启后，企业如何开发 CCER 项目？本文详解方法学选择、项目设计和收益测算。',
    image: 'https://readdy.ai/api/search-image?query=carbon%20credit%20trading%20concept%20digital%20carbon%20coins%20green%20leaves%20financial%20charts%20dark%20background%20professional%20tech%20illustration%20modern%20style&width=600&height=340&seq=blog6&orientation=landscape',
    author: {
      name: '刘浩然',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20data%20scientist%20portrait%20headshot%20wearing%20turtleneck%20intellectual%20look%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=60&height=60&seq=bauth6&orientation=squarish',
      title: 'Firmai 首席科学家',
    },
    tags: ['CCER', '碳汇', '碳交易', '自愿减排'],
    content: `
## CCER 重启背景

2024 年 1 月，全国温室气体自愿减排交易市场（CCER）正式重启。这意味着企业可以将自身的减排项目开发为可交易的碳资产，创造额外的经济收益。

## CCER 项目开发流程

### 第一步：方法学匹配

选择适合项目类型的方法学，目前开放的方法学包括：
- 造林碳汇（CCER-14-001-V01）
- 红树林营造（CCER-14-002-V01）
- 并网光热发电（CCER-01-001-V01）
- 并网海上风电（CCER-01-002-V01）
- 煤矿低浓度瓦斯和风排瓦斯利用（CCER-05-001-V01）

### 第二步：项目设计文件（PDD）编制

PDD 是 CCER 项目的核心文件，需要详细说明：
- 项目边界和基准线情景
- 减排量计算方法
- 监测计划
- 额外性论证

### 第三步：审定与核查

1. 选择审定/核查机构（如中环联合、中国质量认证中心等）
2. 提交 PDD 和相关证明材料
3. 接受文件审查和现场核查
4. 获取审定报告和核查报告

### 第四步：项目登记与减排量签发

1. 在全国温室气体自愿减排注册登记系统登记项目
2. 提交减排量签发申请
3. 经审核后获得 CCER 签发

## 收益测算

以 10MW 分布式光伏项目为例：
- 年发电量：约 1,200 万 kWh
- 减排量：约 10,000 吨 CO2/年
- CCER 价格：假设 60 元/吨
- 年收益：60 万元
- 20 年计入期总收益：1,200 万元

## 企业自主开发 vs 委托开发

### 自主开发
**优势**：收益全部归企业，掌握项目控制权
**劣势**：需要专业团队，时间成本高

### 委托开发（如 Firmai 服务）
**优势**：专业团队操作，成功率高，时间成本低
**劣势**：需要支付服务费（通常为收益的 10-20%）

## Firmai CCER 服务

Firmai 提供 CCER 项目开发全流程服务：
- CCER 项目设计与方法学匹配
- 基准线情景与减排量核算
- 监测计划制定与数据自动采集
- 项目备案与签发全流程管理
- 碳资产交易对接与收益优化

## 风险提示

1. **政策风险**：CCER 政策可能调整，影响项目收益
2. **价格风险**：CCER 价格波动较大，需做好风险对冲
3. **技术风险**：监测数据不准确可能导致减排量核减

## 结语

CCER 为企业提供了将减排行动转化为经济收益的渠道。在双碳目标的大背景下，CCER 市场有望持续扩容，早期布局的企业将获得先发优势。
    `,
  },
];

export function getBlogBySlug(slug: string) {
  return blogPosts.find((post) => post.slug === slug);
}

export function getRelatedPosts(currentSlug: string, limit = 3) {
  const current = blogPosts.find((p) => p.slug === currentSlug);
  if (!current) return blogPosts.slice(0, limit);
  return blogPosts
    .filter((p) => p.slug !== currentSlug && p.category === current.category)
    .slice(0, limit);
}